import { COLOR_BACKGROUND_LEVEL_0_DARK, PAGE_MARGIN_S } from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';
import { customBreakPoint } from '~/styles/break-points';

export const UserMarketingStyle = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: end;
	align-items: end;
	gap: ${PAGE_MARGIN_S}px;

	.button-group {
		display: flex;
		gap: 8px;
		width: 100%;

		${customBreakPoint(768, 'width: auto;')}
	}

	.main-cta-button {
		width: 100%;
		padding: 16px 32px;
		min-width: max-content; // To overwrite the min-width of the component
		min-height: auto; // To overwrite the min-height of the component
		border: none;

		div:last-child span {
			display: flex;
			justify-content: center;
			gap: 8px;
		}

		.icon__container {
			font-size: 18px;
			display: flex;
			justify-content: center;
			align-items: center;

			${customBreakPoint(500, 'font-size: 24px;')}
		}
	}

	.main-cta-button-color {
		background-color: ${COLOR_BACKGROUND_LEVEL_0_DARK};
	}
`;
